import { useEffect, useState } from "react";
import { ref, onValue, off } from "firebase/database";
import { database } from "../constants/firebase";
import { useUser } from "../contexts/UserContext";

const useUnreadActivityCount = () => {
    const { currentUser } = useUser();
    const [unreadCount, setUnreadCount] = useState(0);

    useEffect(() => {
        if (!currentUser?.uid) return;

        const uid = currentUser.uid;
        const requestsRef = ref(database, `Users/${uid}/friendRequests`);

        const unsubscribe = onValue(requestsRef, (snapshot) => {
            if (!snapshot.exists()) {
                setUnreadCount(0);
                return;
            }

            const data = snapshot.val();
            // Count how many friend requests have status "received"
            const count = Object.values(data).filter(status => status === "received").length;
            setUnreadCount(count);
        });

        return () => off(requestsRef);
    }, [currentUser]);

    return unreadCount;
};

export default useUnreadActivityCount;
